<template>
  <div class="width-100p">
    <v-btn
      depressed
      large
      block
      color="white"
      class="ma-0"
      @click="dialog = true"
    >
      Generate activation link
    </v-btn>

    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5">Create activation link</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog()"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="crud-card-text">
          <p v-if="!activationLink">
            Generate a new activation link for this user.
          </p>
          <p v-else>
            New activation link for {{ testator.fullName }} ({{
              testator.email
            }})<br /><br />
            <a :href="activationLink">{{ activationLink }}</a>
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                v-if="!activationLink"
                class="left-edit-btn"
                :loading="buttonLoading"
                rounded
                depressed
                color="primary"
                @click="createActivationLink()"
              >
                Create new activation link
              </v-btn>
              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                :outlined="!activationLink"
                color="primary"
                @click="closeDialog()"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import { CREATE_ACTIVATION_LINK_MUTATION } from '../../../constants/graphql/users';
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';

  export default {
    name: 'CreateActivationLink',
    components: {
      ErrorSnackbar,
    },
    props: {
      testator: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        dialog: false,
        showError: false,
        activationLink: null,
        buttonLoading: false,
      };
    },
    methods: {
      createActivationLink() {
        this.buttonLoading = true;
        const testatorId = this.testator.id;

        this.$apollo
          .mutate({
            mutation: CREATE_ACTIVATION_LINK_MUTATION,
            variables: {
              testatorId,
            },
          })
          .then(response => {
            this.buttonLoading = false;
            this.activationLink = response.data.createActivationLink;
          })
          .catch(error => {
            this.closeDialog();
            this.showError = true;
            throw error;
          });
      },
      closeDialog() {
        this.dialog = false;
        this.activationLink = null;
        this.buttonLoading = false;
      },
    },
  };
</script>
